import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base/base.service';
import { SessionUserHashManagerService } from './session-user-hash-manager/session-user-hash-manager.service';

@Injectable()
export class AdministrationService extends BaseService {
  
  
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  createMfaCode(userId) {
    return this.http.post(this.apiUrl + 'api/Communication/CreateMfaCode?userId=' + userId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        return data;
      }), catchError(this.handleError('createMfaCode'))
    );
  }

  validateMfaCode(data) {
    return this.http.post(this.apiUrl + 'api/Communication/validateMfaCode', data, this.prepareOptions(data)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('validateMfaCode'))
    );
  }

  checkMfaValidation(userId) {
    return this.http.get(this.apiUrl + 'api/Communication/CheckMfaValidation?userId=' + userId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('checkMfaValidation'))
    );
  }

  updateMfaSettings(data) {
    return this.http.post(this.apiUrl + 'api/Communication/UpdateMfaSettings', data, this.prepareOptions(data)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('updateMfaSettings'))
    );
  }

}
